// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".country-phone-input .dropdown[data-v-2db0814c]:focus{outline:none;color:grey}.send.sending[data-v-2db0814c]{opacity:.85;cursor:not-allowed}.send-spinner[data-v-2db0814c]{display:inline-block;margin-right:6px;animation:send-spin-2db0814c .8s linear infinite}@keyframes send-spin-2db0814c{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
